import { render, staticRenderFns } from "./BlockType11Grid.vue?vue&type=template&id=239a2458&scoped=true"
import script from "./BlockType11Grid.vue?vue&type=script&lang=ts"
export * from "./BlockType11Grid.vue?vue&type=script&lang=ts"
import style0 from "./BlockType11Grid.vue?vue&type=style&index=0&id=239a2458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239a2458",
  null
  
)

export default component.exports